module.exports = __webpack_public_path__ + "static/media/branding.7ea1bdd8.svg";